import type { FaireProductEntity } from "../../entity_types/product";

export const p_ptmudb7esh: FaireProductEntity = {
  token: "p_ptmudb7esh",
  type: "product",
  name: "Leopard Sports Mom Hoodie | Gameday | Baseball Mom",
  brandToken: "b_7cnu2s5cyz",
  brandName: "You Play I Pray",
  imageUrl:
    "https://cdn.faire.com/fastly/c52d90343eeedea781b59f2051fb68f24ce86a2f65c7aed2ff9b6821466b1875.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9ac893fdaf9fcf314ad4c63ac331b15ce8374510b63d3909c02f73203898f3da.jpeg",
    "https://cdn.faire.com/fastly/d192e8ab39ec947f81420f47c70912589123910897a67ff369be9c11f8f8d9d5.jpeg",
  ],
  priceDollars: 25,
  description:
    "Leopard Hooide is the softest hoodie we have ever offered. Beautiful neutral colors work with any team colors. ",
  tags: [],
  msrpDollars: 50,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:47.409Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
